module.exports = __webpack_public_path__ + "img/HU12321942.5d435b1d.png";